import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { useLang } from "@/context/LanguageContext";
import WheelVisual from "@/components/WheelVisual";

export default function NotFound() {
  const { t } = useLang();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-8 px-5 py-24 text-center">
      <SEO title={`${t("notfound.title")} | ميرو`} description={t("notfound.sub")} path="/404" />
      <WheelVisual className="h-28 w-28 opacity-80" />
      <p className="font-display text-7xl font-extrabold text-gold">404</p>
      <h1 className="text-2xl font-bold text-white">{t("notfound.title")}</h1>
      <p className="max-w-md text-mist">{t("notfound.sub")}</p>
      <div className="mt-2 flex flex-wrap justify-center gap-3.5">
        <Link to="/" className="btn-gold" data-testid="notfound-home-link">{t("notfound.home")}</Link>
        <Link to="/services" className="btn-ghost" data-testid="notfound-services-link">{t("notfound.services")}</Link>
      </div>
    </main>
  );
}
